import { FC } from 'react'
import { Loader, LoaderColor, LoaderSize } from '@enbw/ui-react'
import styles from './styles.module.scss'

type LoadingPageProps = {
  fullScreen?: boolean
}

export const LoadingPage: FC<LoadingPageProps> = ({ fullScreen = false }) => {
  return (
    <div className={`${styles.loadingPage} ${fullScreen ? styles.loadingPageFullScreen : styles.loadingPageEmbedded}`}>
      <Loader size={LoaderSize.Large} color={LoaderColor.Brand} />
    </div>
  )
}
